export const GET_DOCTORS_PAGINATION = "GET_DOCTORS_PAGINATION";
export const SET_DOCTORS_PAGINATION = "SET_DOCTORS_PAGINATION";
export const DELETE_DOCTOR = "DELETE_DOCTOR";
export const POST_NEW_DOCTOR = "POST_NEW_DOCTOR";
export const UPDATE_DOCTOR = "UPDATE_DOCTOR";
export const GET_DOCTOR = "GET_DOCTOR";
export const SET_DOCTOR = "SET_DOCTOR";
export const SET_DOCTOR_TITLES = "SET_DOCTOR_TITLES";
export const GET_DOCTOR_TITLES = "GET_DOCTOR_TITLES";
